import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'app-lang-list',
  templateUrl: './lang-list.component.html',
  standalone: true,
  imports: [],
})
export class LangListComponent extends BaseComponent implements OnInit {
  ngOnInit(): void {
    this.onLangChange();
  }

  onLangChange() {
    this.translate.onLangChange.subscribe(lang => {
      this.currentLang = lang.lang as 'ar' | 'en';
      document.getElementsByTagName('body')[0].dir =
        this.currentLang === 'ar' ? 'rtl' : 'ltr';
    });
  }

  langChange(lang: 'ar' | 'en') {
    this.translate.setDefaultLang(lang);
    this.translate.use(lang);
  }
}
